import clsx from 'clsx';
import React, { FC } from 'react';
import { WithChildren } from '../react18MigrationHelpers';

type Props = {
  className?: string;
  scroll?: boolean;
  height?: number;
  style?: React.CSSProperties;
};

const KTCardBody: FC<Props & WithChildren> = (props) => {
  const { className, scroll, height, children, style } = props;
  return (
    <div
      className={clsx(
        'card-body',
        className && className,
        {
          'card-scroll': scroll,
        },
        height && `h-${height}px`
      )}
      style={style}
    >
      {children}
    </div>
  );
};

export { KTCardBody };
